import React, { useState } from 'react';
import axios from 'axios';
import { Modal } from "react-bootstrap"
import CloseIcon from '@components/icons/CloseIcon';
import BrightCallForm from '@components/forms/BrightCallForm';
import "./Brightcall.scss"
import Timer from './Timer';
const Brightcall = ({ setBright, developer, property, propertyURL }) => {
    const [show, setShow] = useState(true)

    const [done, onDone] = useState(false)
    const [completed, onCompleted] = useState(false)
    const handleClose = () => { setShow(false); setBright(false);onCompleted(false);onDone(false) };
    const [phone, sePhone] = useState("")
    return (
        <Modal show={show} onHide={handleClose} centered backdrop="static" className="mortgage-modal bright">
            <Modal.Body className="mortgage-modal-body">
                <div className="mortgage-modal-header">
                    <div className="content-section">
                        <h3 className="title">{done ? "Thank you for requesting a call" : completed ? "Thank you for requesting a call" : "Get a call within 55 seconds 📞"}</h3>
                        {done ? <p className="description">We're now checking for an available person.</p> : completed ? <p className="description"></p> : <p className="description"><b>Leave your number</b> below
                            <br/>and we will call you right away!</p>}
                    </div>
                    <CloseIcon onClick={handleClose} />
                </div>
                {done ? <Timer phone={phone} /> : completed ? <div className='comp-bk'><p>Thank you for your inquiry!
                    <br/>We will get back to you as soon as possible!</p>
                        <button onClick={handleClose} className='button button-blue close-btn'>Close</button>
                    </div> :
                <BrightCallForm developer={developer} onDone={onDone} onCompleted={onCompleted} sePhone={sePhone} property={property} propertyURL={propertyURL}/>}
            </Modal.Body>
        </Modal>

    );
};

export default Brightcall;